//const qs = require('querystring')

export default {
    name: "login2FA",
    data() {
        return {
            TFAcode: null,
            TFAcode_recovery: null,
            RememberMe: false,
            RememberMachine: false
        };
    },
    props: {
        msg: String
    },
    created: function() {
        this.$store.commit('SET_LAYOUT', 'simple-layout')
    },
    components: {

    },
    methods: {

        async loginTFA() {

            const otpLogin=sessionStorage.getItem("LOGIN_2FA_MODE")=="otp";
            this.$root.authObj=await this.$api.loginTFA(this.TFAcode, { otpLogin });

            if (this.$root.authObj==null) {
                return;
            }

            sessionStorage.removeItem("LOGIN_2FA_MODE");
            this.$root.login(false);

        },

        //???????????????????????????????????????????????
        async loginTFArecovery() {

            this.$root.authObj=await this.$api.loginTFARecovery("LOGINTFARECOVERY", this.TFAcode_recovery);

            if (this.$root.authObj==null)
                return;

            this.$root.login(false);

        }
    }
}
